import { render, staticRenderFns } from "./TablePaginationV2.vue?vue&type=template&id=bb9d6fd6"
import script from "./TablePaginationV2.vue?vue&type=script&lang=ts"
export * from "./TablePaginationV2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports